/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import useHijos from "../../../hooks/useHijos";
import Hijos from "../../../components/hoc/Hijos";
import Swal from "sweetalert2";

const templete = {
  NombreH: "",
  CuentaPre: "",
  VariableID: "",
  ProveedorID: "",
  Cantidad: "",
  X: "",
  Unidades: "",
  MostrarVariable: false,
  IsChecked: true,
  Fecha: "",
  Opcion: "",
  Cuantos: "",
  Costo: "",
  Subtota: "",
  Iva: "",
  Total: "",
};

export default function ModalAdd({
  modalHijo,
  toggleHijo,
  PadreID,
  HijoID,
  NivelID,
  token,
  id,
  cliente_id,
  setIsChecked,
  PresupuestosGetService,
  PadresMontoGetService,
}) {
  const { error, message, success, HijosHijosAdd_Service } = useHijos();

  const [Arreglo, setArreglo] = useState([templete]);
  const [Numerica, setNumerica] = useState(null);

  useEffect(() => {
    if (success === true) {
      PresupuestosGetService(id, token);
      toggleHijo();
    }
  }, [PresupuestosGetService, success]);

  useEffect(() => {
    if (success == true) {
      PadresMontoGetService(id, token);
    }
  }, [PadresMontoGetService, success]);

  const guardar = () => {
    const data = new FormData();
    data.append("PadreID", PadreID);
    data.append("HijoID", HijoID);
    data.append("items", JSON.stringify(Arreglo));
    data.append("nivel_id", parseInt(NivelID) + 1);
    data.append("subpadre", "No");
    HijosHijosAdd_Service(data, token);

    Swal.fire({
      title: "Registrando cuenta hijo",
      text: "Loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      icon: "question",
      onOpen: () => {
        Swal.showLoading();
      },
    });
  };

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
      toggleHijo();
    }
  }, [message, success]);

  return (
    <>
      <Modal
        isOpen={modalHijo}
        toggle={toggleHijo}
        size="lg"
        style={{ maxWidth: "1600px", width: "80%" }}
      >
        <ModalHeader className="backend_titulo" toggle={toggleHijo}>
          Agregar Hijos
        </ModalHeader>
        <ModalBody>
          {Arreglo.map((item, index) => {
            return (
              <Hijos
                key={index}
                item={item}
                index={index}
                Arreglo={Arreglo}
                templete={templete}
                Numerica={Numerica}
                token={token}
                cliente_id={cliente_id}
                setArreglo={setArreglo}
                setNumerica={setNumerica}
                setIsChecked={setIsChecked}
                PadreID={PadreID}
                HijoID={HijoID}
              />
            );
          })}
        </ModalBody>
        <ModalFooter>
          <Button className="backend_boton" onClick={() => guardar()}>
            Guardar y Cerrar
          </Button>
          <Button color="danger" onClick={toggleHijo}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
